"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./Fabric'));

//# sourceMappingURL=index.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Fabric/index.js
 ** module id = 45
 ** module chunks = 0
 **/